
import Lien from "../../../../common/components/ob1/Lien.vue";

export default {
    components: {
        Lien
    },
    props: {
        offer: {
            type: Object,
            required: true
        },
    },
}
